import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Landing from "@/pages/Landing";
import Admin from "@/pages/Admin";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import Rgpd from "@/pages/Rgpd";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <div className="App bg-bone text-ink antialiased">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/politica-de-privacidade" element={<Privacy />} />
          <Route path="/termos" element={<Terms />} />
          <Route path="/rgpd" element={<Rgpd />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="bottom-center" />
    </div>
  );
}

export default App;
